import "@/App.css";
import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/components/site/Landing";

function App() {
  useEffect(() => {
    document.title = "MySolarGarden — Grow food. Generate power.";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain">
        <Landing />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#161917",
              border: "1px solid #2C312E",
              color: "#F2F0E9",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
